module.exports = __webpack_public_path__ + "static/media/branding.c27d41e0.png";